<template>
  <div>
    <validation-observer ref="transportRouteValidator">
      <v-form v-if="forms">
        <v-card flat>
          <v-toolbar flat>
            <v-toolbar-title>{{ $route.params.id ? 'ルート編集' : 'ルート追加' }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pb-0">
            <!-- コード -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{required: true, alpha_num_only: true, max: 10 }"
                  class="requiredMark"
                  name="コード"
                >
                  <v-text-field
                    v-model="forms.code"
                    :error-messages="errors"
                    dense
                    label="コード"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    placeholder="例）R001"
                    required
                  >
                    <template v-slot:label>
                      <span>コード</span>
                      <span class="ml-1">
                        ({{ forms.code?.length || 0 }} / 10)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col
                cols="12"
                md="2"
              >
                <v-checkbox
                  v-model="forms.invisible"
                  label="非表示にする"
                  hide-details="auto"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                最近使用したコード:&nbsp;<strong>{{ forms.recent_registered_codes }}</strong>
              </v-col>
            </v-row>
            <!-- コード -->

            <!-- ルート名 -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|max:50"
                  name="ルート名"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="forms.name"
                    :error-messages="errors"
                    dense
                    hide-details="auto"
                    label="ルート名"
                    outlined
                    persistent-placeholder
                    placeholder="例）処分ルート１"
                    required
                  >
                    <template v-slot:label>
                      <span>ルート名</span>
                      <span class="ml-1">
                        ({{ forms.name?.length || 0 }} / 50)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ numeric: true, min_value: 0, max_value: 99999 }"
                  name="運搬ルート表示順"
                >
                  <v-text-field
                    v-model="forms.sort_priority"
                    :error-messages="errors"
                    dense
                    :show-size="1000"
                    label="運搬ルート表示順"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    type="number"
                    @keydown.69.prevent
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <!-- ルート -->
            <v-row v-if="forms.transport_route_sections">
              <v-col>
                <v-card flat outlined tile>
                  <v-card-title>ルート</v-card-title>
                  <v-card-text>
                    <div
                      v-for="(section, index) in forms.transport_route_sections"
                      :key="index"
                    >
                      <template v-if="!section._destroy">
                        <transport-route-section
                          :section="section"
                          :transports="section.section === 1 ?  first_transports : transports"
                          :traders="traders"
                          :index="index"
                          :disposer-id="forms.disposer_id"
                          :disposer-location-code="forms.disposer_location_code"
                          :last-row="index === (forms.transport_route_sections.length - 1)"
                          :active-row="activeRowCounter"
                          :editable="forms.editable"
                          @removeCallback="removeButtonClickCallback"
                          @changeCallback="changeCallback"
                          @changeLocationCallback="changeLocationCallback"
                        />
                      </template>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      :disabled="activeRowCounter >= 5 || !forms.editable"
                      color="info"
                      @click="addDetailButtonClickEvent"
                    >
                      追加
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
            <!-- /ルート -->
          </v-card-text>
          <v-card-title>処分業者</v-card-title>
          <v-card-text>
            <!-- 処分場 -->
            <!-- <v-row>
              <v-col cols="12" md="5">
                <v-select
                  v-model="forms.disposer_id"
                  :items="disposers"
                  :disabled="!forms.editable"
                  class="d-none"
                  dense
                  filled
                  hide-details="auto"
                  label="会社名"
                  outlined
                  readonly
                  persistent-placeholder
                  style="font-size: 90%"
                >
                  <template v-slot:item="slotProps" >
                    {{slotProps.item.name}}
                  </template>
                </v-select>
              </v-col>
              <v-col cols="12" md="5">
                <v-select
                  v-model="forms.disposer_location_code"
                  :items="disposerLocations"
                  :disabled="!forms.editable"
                  class="d-none"
                  dense
                  filled
                  hide-details="auto"
                  label="事業場"
                  outlined
                  readonly
                  persistent-placeholder
                  style="font-size: 90%"
                >
                  <template v-slot:item="slotProps" >
                    {{slotProps.item.name}}
                  </template>
                </v-select>
              </v-col>
            </v-row> -->
            <!-- /処分場 -->

            <!-- 処分場 -->
            <v-row>
              <v-col cols="12" md="5">
                <v-text-field
                  v-model="forms.disposer_name"
                  dense

                  hide-details="auto"
                  label="会社名"
                  outlined
                  persistent-placeholder
                  readonly
                  style="font-size: 90%"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-text-field
                  v-model="forms.disposer_location_name"
                  dense
                  filled
                  hide-details="auto"
                  label="事業場"
                  outlined
                  persistent-placeholder
                  readonly
                  style="font-size: 90%"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <!-- /処分場 -->

            <!-- 処分方法 -->
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="処分方法"
                >
                  <v-select
                    v-model="forms.disposal_method_id"
                    :items="disposalMethods"
                    :error-messages="errors"
                    clearable
                    dense
                    hide-details="auto"
                    label="処分方法"
                    outlined
                    persistent-placeholder
                    style="font-size: 90%"
                  ></v-select>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /処分方法 -->

            <!-- 対象品目 -->
            <v-row>
              <v-col>
                <item-autocomplete
                  v-model="target_item_ids"
                  :items="targetItems"
                  label="対象品目"
                  multiple
                  clearable
                  chips
                  small-chips
                  deletable-chips
                  dense
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  classes="target-items-select"
                />
                <v-select
                  v-if="false"
                  v-model="target_item_ids"
                  :items="targetItems"
                  item-text="text"
                  item-value="value"
                  label="対象品目"
                  multiple
                  chips
                  small-chips
                  deletable-chips
                  dense
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  style="font-size: 90%"
                  class="target-items-select"
                ></v-select>
              </v-col>
            </v-row>
            <!-- /対象品目 -->
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="cancelButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              登録
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>

    <!-- アップグレード誘導モーダル -->
    <trial-plan-guide-dialog
      :enable-dialog="enableTrialPlanGuideDialog"
      :from-transport-route="true"
      @closeCallback="dialogCloseCallback"
    />
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import TransportRouteSection from './components/_Section'
import TrialPlanGuideDialog from '../../dialogs/_TrialPlanGuideDialog'
import ItemAutocomplete from "@/driver/components/ItemAutocomplete.vue";

export default {
  name: 'TransportRouteForm',
  components: {
    ItemAutocomplete,
    TransportRouteSection,
    TrialPlanGuideDialog
  },
  mixins: [],
  props: {},
  data() {
    return {
      activeRowCounter: 0,
      disposer_location_name: null,
      forms: null,
      isLoading: false,
      first_transports: [],
      transports: [],
      traders: [],
      disposers: [],
      disposerLocations: [],
      disposalMethods: [],
      items: [],
      generalItems: [],
      relatedLocation: null,
      enableTrialPlanGuideDialog: false,
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isTrialPlan: 'use_trial_plan',
    }),
    /**
     * 処分業者に応じて適切な品目リストを返す
     */
    targetItems() {
      const disposer = this.disposers.find((v) => v.value === this.forms.disposer_id)
      if (disposer && disposer.type === 'GeneralWasteDisposal') {
        return this.generalItems
      } else {
        return this.items
      }

    },
    /**
     * 選択されている品目IDの配列を取得/設定
     */
    target_item_ids: {
      get() {
        return this.forms.transport_route_items
          .filter(item => !item._destroy)
          .map(item => item.item_id)
      },
      set(itemIds) {
        const disposer = this.disposers.find((v) => v.value === this.forms.disposer_id)
        const itemType = (disposer && disposer.type === 'GeneralWasteDisposal') ? 'GeneralItem' : 'Item'

        // 既存のアイテムで選択から外れたものに_destroyフラグを立てる
        this.forms.transport_route_items.forEach(item => {
          if (!itemIds.includes(item.item_id)) {
            item._destroy = true
          } else {
            item._destroy = false
          }
        })

        // 新しく追加されたアイテムを追加
        itemIds.forEach(itemId => {
          const exists = this.forms.transport_route_items.find(item => item.item_id === itemId)
          if (!exists) {
            this.forms.transport_route_items.push({
              id: null,
              item_id: itemId,
              item_type: itemType,
              _destroy: false
            })
          }
        })
      }
    },
  },
  watch: {
    /*
     * リストの変更を検知.
     * リストとして、削除されたデータについてもsubmitされるまでは保持しているので
     * 削除された区間を除くアクティブな登録数を算出する.
     */
    'forms.transport_route_sections' : function () {
      let active_row_count = 0
      for (const detail of this.forms.transport_route_sections) {
        if (!detail._destroy) {
          active_row_count = active_row_count + 1
        }
      }
      this.activeRowCounter = active_row_count
    },
    /*
     * 処分業者IDが変更されたら、typeが変わった場合のみ選択されている品目をリセット
     * ただし、初期読み込み中はリセットしない
     */
    'forms.disposer_id'(newId, oldId) {
      if (oldId) {
        const newDisposer = this.disposers.find((v) => v.value === newId)
        const oldDisposer = this.disposers.find((v) => v.value === oldId)
        const newType = newDisposer?.type === 'GeneralWasteDisposal' ? 'general' : 'normal'
        const oldType = oldDisposer?.type === 'GeneralWasteDisposal' ? 'general' : 'normal'

        if (newType !== oldType) {
          this.target_item_ids = []
        }
      }
    },
  },
  created() {
    /**
     * 処分業者
     */
    const fetchDisposersPromise = this.fetchTraders({ without_invisible: true, search_type: 'disposal', include_general_waste_disposer: true }).then((content) => {
      this.disposers = content.traders
    })
    /**
     * 運搬業者
     */
    const fetchTransportsPromise = this.fetchTraders({ without_invisible: true, search_type: 'transport' }).then((content) => {
      this.transports = content.traders
    })

    /**
     * 運搬業者
     */
    const fetchFirstTransportsPromise = this.fetchTraders({ without_invisible: true, search_type: 'transport', self_emission: true, include_proxy_entry: true }).then((content) => {
      this.first_transports = content.traders
    })

    const fetchDisposalMethodsPromise = this.fetchDisposalMethods().then((content) => {
      this.disposalMethods = content.disposal_methods
    })
    /**
     * 品目
     */
    const fetchItemsPromise = this.fetchItems().then((content) => {
      this.items = content.items
    })
    /**
     * 一般廃棄物品目
     */
    const fetchGeneralItemsPromise = this.fetchGeneralItems().then((content) => {
      this.generalItems = content.general_items
    })
    /**
     * 全件
     */
    const fetchTradersPromise = this.fetchTraders({ without_invisible: true, search_type: 'all', only_location_registered: true, include_general_waste_disposer: true }).then((content) => {
      this.traders = content.traders
    })

    // すべてのマスターデータが読み込まれてからフォームデータを読み込む
    Promise.all([
      fetchDisposersPromise,
      fetchTransportsPromise,
      fetchFirstTransportsPromise,
      fetchDisposalMethodsPromise,
      fetchItemsPromise,
      fetchGeneralItemsPromise,
      fetchTradersPromise
    ]).then(() => {
      if (this.$route.params.id) {
        this.editTransportRoute({id: this.$route.params.id}).then((content) => {
          this.forms = content
          // transport_route_sectionsが存在しない場合は空配列で初期化
          if (!this.forms.transport_route_sections) {
            this.forms.transport_route_sections = []
          }
          // transport_route_itemsが存在しない場合は空配列で初期化
          if (!this.forms.transport_route_items) {
            this.forms.transport_route_items = []
          }
          this.disposerChangeEvent()
        })
      } else {
        this.newTransportRoute().then((content) => {
          this.forms = content
          // transport_route_sectionsが存在しない場合は空配列で初期化
          if (!this.forms.transport_route_sections) {
            this.forms.transport_route_sections = []
          }
          // transport_route_itemsが存在しない場合は空配列で初期化
          if (!this.forms.transport_route_items) {
            this.forms.transport_route_items = []
          }
        })
      }
    })

  },
  methods: {
    ...mapActions('DriverMasterTransportRoute', {
      newTransportRoute: 'new',
      editTransportRoute: 'edit',
      createTransportRoute: 'create',
      updateTransportRoute: 'update',
      checkCount: 'check',
    }),
    ...mapActions('DriverMasterSearchTrader', {
      fetchTraders: 'index',
    }),
    ...mapActions('DriverMasterSearchTraderLocation', {
      fetchDisposerLocations: 'index',
    }),
    ...mapActions('DriverMasterSearchDisposalMethod', {
      fetchDisposalMethods: 'index',
    }),
    ...mapActions('DriverMasterSearchItem', {
      fetchItems: 'index',
    }),
    ...mapActions('DriverMasterSearchGeneralItem', {
      fetchGeneralItems: 'index',
    }),
    ...mapActions("DriverMasterTransportRouteCodeValidation", {
      codeValidation: 'exists'
    }),
    /**
     * 処分業者 チェンジイベント
     * ・展開されているリストから名称をセット
     * ・処分事業場の展開
     */
    disposerChangeEvent () {
      let disposer = this.disposers.find((v) => v.value === this.forms.disposer_id)
      if (disposer) {
        this.forms.disposer_name = disposer.name
        this.fetchDisposerLocations({ id: this.forms.disposer_id }).then((content) => {
          this.disposerLocations = content.locations
        })
      } else {
        this.forms.disposer_id = null
        this.forms.disposer_name = null
        this.disposerLocations = []
      }
    },
    /**
     * データの再構築
     */
    removeButtonClickCallback () {
      let replacedList = []
      let section = 1
      for (let i = 0; i < this.forms.transport_route_sections.length; i++) {
        if (!this.forms.transport_route_sections[i]._destroy) {
          this.forms.transport_route_sections[i].section = section
          section = section + 1
        }
        replacedList.push(this.forms.transport_route_sections[i])
      }
      this.forms.transport_route_sections = replacedList

      // アクティブな最終区間を抽出する
      const activeRoutes = replacedList.filter((section) => !section._destroy)
      const lastRoute = activeRoutes.pop()
      // 最終区間の
      if (lastRoute) {
        this.forms.disposer_id = null
        this.forms.disposer_name = null
        this.forms.disposer_location_code = null
        this.forms.disposer_location_name = null
        this.forms.disposer_id = lastRoute.trader_id
        this.forms.disposer_location_code = lastRoute.trader_location_code
      }
    },
    addDetailButtonClickEvent() {
      if (this.activeRowCounter >= 5)
        return false

      let max_section = 0
      for (let i = 0; i < this.forms.transport_route_sections.length; i++) {
        if (!this.forms.transport_route_sections[i]._destroy && max_section < this.forms.transport_route_sections[i].section) {
          max_section = this.forms.transport_route_sections[i].section
        }
      }

      /**
       * 処分業者欄をクリア
       */
      this.forms.disposer_id = null
      this.forms.disposer_name = null
      this.forms.disposer_location_code = null
      this.forms.disposer_location_name = null

      max_section = max_section + 1
      let obj = {
        id: null,
        code: null,
        section: max_section,
        transport_id: null,
        transports: [],
        trader_id: null,
        traders: [],
        trader_location_code: null,
        trader_locations: [],
        _destroy: false,
      }
      this.forms.transport_route_sections.push(...[obj])

    },
    cancelButtonClickEvent () {
      this.$router.push({ name: 'DriverMasterTransportRoutes' })
    },
    registerButtonClickEvent () {
      let $self = this
      // お試しプランでかつ 非表示を選択していない場合
      if (this.isTrialPlan && !this.forms.invisible) {
        let params = { without_invisible: true}
        this.checkCount(params).then((content) => {
          if (content.pagination.total_count < 10) {
            this.$refs.transportRouteValidator.validate().then((result) => {
              if(result) {
                $self.sendRegistrationInformation()
              }
            })
          } else {
            this.enableTrialPlanGuideDialog = true
          }
        })
      } else {
        this.$refs.transportRouteValidator.validate().then((result) => {
          if(result) {
            $self.sendRegistrationInformation()
          }
        })
      }
    },
    sendRegistrationInformation () {
      let sections = []
      for (let i = 0; i < this.forms.transport_route_sections.length; i++) {
        let section = {
          id: this.forms.transport_route_sections[i].id,
          section: this.forms.transport_route_sections[i].section,
          transport_id: this.forms.transport_route_sections[i].transport_id,
          trader_id: this.forms.transport_route_sections[i].trader_id,
          trader_location_code: this.forms.transport_route_sections[i].trader_location_code,
          _destroy: this.forms.transport_route_sections[i]._destroy,
        }
        sections.push(section)
      }
      let transportRouteItems = []
      for (let i = 0; i < this.forms.transport_route_items.length; i++) {
        let item = {
          id: this.forms.transport_route_items[i].id,
          item_id: this.forms.transport_route_items[i].item_id,
          item_type: this.forms.transport_route_items[i].item_type,
          _destroy: this.forms.transport_route_items[i]._destroy,
        }
        transportRouteItems.push(item)
      }
      let params = {
        code: this.forms.code,
        invisible: this.forms.invisible,
        name: this.forms.name,
        sort_priority: this.forms.sort_priority,
        transport_route_sections_attributes: sections,
        disposer_id: this.forms.disposer_id,
        disposer_location_code: this.forms.disposer_location_code,
        disposal_method_id: this.forms.disposal_method_id,
        transport_route_items_attributes: transportRouteItems,
      }
      if (this.$route.params.id) {
        this.updateTransportRoute({ id: this.$route.params.id, params: params }).then(() => {
          this.$router.push({ name: 'DriverMasterTransportRoutes' })
        })
      } else {
        this.createTransportRoute({ params: params }).then(() => {
          this.$router.push({ name: 'DriverMasterTransportRoutes', params: { resetPagination: 'true' } })
        })
      }
    },
    /**
     * 処分業者変更コールバック
     * @param value
     */
    changeCallback (value) {
      this.forms.disposer_id = value
      this.forms.disposer_location_code = null;
      this.forms.disposer_location_name = null;
      this.disposerChangeEvent();
    },
    /**
     * 処分事業場変更コールバック
     * @param value
     */
    changeLocationCallback (value) {
      this.forms.disposer_location_code = value
      this.forms.disposer_location_name = null
      let disposerLocation = this.disposerLocations.find((v) => v.value === value)
      if (disposerLocation) {
        this.forms.disposer_location_name = disposerLocation.name
      }
    },
    /**
     * ダイアログ 閉じるボタンコールバック
     */
    dialogCloseCallback() {
      this.enableTrialPlanGuideDialog = false;
    },
  }
}
</script>

<style scoped>
.target-items-select ::v-deep .v-chip {
  background-color: white !important;
  border: 1px solid #9e9e9e;
}

.target-items-select ::v-deep .v-chip .v-chip__content {
  color: rgba(0, 0, 0, 0.87);
}
</style>
